import { motion } from 'framer-motion';
import styled from 'styled-components';

import { mediaTablet } from 'utils/styles/responsive';
import theme from 'utils/styles/theme';

interface ImageSliderWrapperProps {
  onMouseMove?: any;
  $nextImage?: string;
  $innerHeight?: number;
}

interface DotProps {
  isActive?: boolean;
}

export const ImageSliderWrapper = styled(motion.div)<ImageSliderWrapperProps>`
  height: ${({ $innerHeight }) => $innerHeight && `${$innerHeight}px`};
  display: flex;
  justify-content: center;
  align-items: center;
  background: url(${({ $nextImage }) => $nextImage || ''}) no-repeat center
    center / cover;
  object-fit: cover;
  cursor: grab;

  ${mediaTablet(`
    max-height: unset;
    height: 100vh;
  `)}
`;

export const DragWrapper = styled(motion.div)`
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const DragContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
`;

export const Image = styled(motion.img)`
  object-fit: cover;
  pointer-events: none;
  width: 100%;
  height: 100%;
`;

export const DotsContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  padding: 26px 0;
  z-index: 1;
`;

export const Dot = styled.span<DotProps>`
  height: 8px;
  width: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  opacity: ${({ isActive }) => (isActive ? 1 : 0.2)};
  border-radius: 50%;
  display: inline-block;
  margin: 0 5px;
  z-index: 10;
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: flex-end;
`;

export const IndicatorWrapper = styled.div`
  height: 60px;
  width: 60px;
  position: sticky;
  bottom: 62px;
  left: 0;
  margin: 0 0 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${theme.layout.zIndex.overlay};

  ${mediaTablet(`
    bottom: 0;
  `)}
`;
